module.exports = __webpack_public_path__ + "media/images/icons/filled/switcher-04c4b90a4592daa42dc261f2852b4319.svg";